import { styled, keyframes } from '@mui/material';

import { TeamLogo } from '../TeamLogo';

const SkeletonAnimation = keyframes`
    0% {
      background-color: hsl(200, 20%, 80%);
    }
    100% {
      background-color: hsl(200, 20%, 95%);
    }
`

const StyledSingleTeamSkeleton = styled('div')(({theme}) => ({
    display: 'flex',
    overflow: 'hidden',
    flex: 1,
    padding: theme.spacing(1)
}))

const StyledTeamDetails = styled('div')({
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'column',
    justifyContent: 'center',
    marginRight: 8
})

const StyledSingleTeamName = styled('span')({
    background: '#ddd',
    width: 100,
    height: 16,
    fontSize: 12,
    lineHeight: 1.1,
    marginBottom: 2,
    borderRadius: 2,
    animationName: SkeletonAnimation,
    animationDirection: 'alternate',
    animationIterationCount: 'infinite',
    animationTimingFunction: 'linear',
    animationDuration: '1s'
})

export const SingleTeamSkeleton = () => (
    <StyledSingleTeamSkeleton data-testid="single-team-skeleton">
        <TeamLogo />
        <StyledTeamDetails>
            <StyledSingleTeamName />
        </StyledTeamDetails>
    </StyledSingleTeamSkeleton>
)